var uiPagination = {
	caption: "Pagination",
	page: "Page {page}",
	first: "First page",
	previous: "Previous page",
	next: "Next page",
	last: "Last page"
};
var en = {
	uiPagination: uiPagination
};

export { en as default, uiPagination };
